import script from "./UserSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserSettings.vue?vue&type=script&setup=true&lang=ts"

import "./UserSettings.vue?vue&type=style&index=0&id=4148664e&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4148664e"]])

export default __exports__